import React from 'react';
import { ImportStats } from '../types';

interface ImportProgressStepProps {
    progress: number;
    stats: ImportStats;
}

export const ImportProgressStep: React.FC<ImportProgressStepProps> = ({ progress, stats }) => {
    return (
        <div className="py-s8 text-center">
            <div
                className="progress-wrap progress-lg mb-s6"
                role="progressbar"
                aria-valuenow={progress}
                aria-valuemin={0}
                aria-valuemax={100}
                aria-label="Progresso da importação"
            >
                <div className="progress-fill" style={{ width: `${progress}%` }} />
            </div>

            <h3 className="mb-s2 text-lg font-semibold text-default">
                Importando contatos...{' '}
                <span className="font-mono tabular-nums">{progress}%</span>
            </h3>
            <p className="text-muted">
                <span className="font-mono tabular-nums text-success-text">{stats.success}</span> importados,{' '}
                <span className="font-mono tabular-nums text-danger-text">{stats.error}</span> falhas
            </p>
            <p className="mt-s4 text-sm text-muted">
                Por favor, não feche esta janela.
            </p>
        </div>
    );
};
